import axios from "axios";

const initialState = () => {
  return {
    calcSalary: {
      loading: false,
      salary: null
    }
  }
}

export default {
  state: initialState(),
  getters: {
    getCalcSalary: (state) => state.calcSalary
  },
  mutations: {
    MUTATE_CALC_SALARY(state, payload) {
      state.calcSalary.salary = payload;
    },
    MUTATE_CALC_SALARY_LOADING(state, payload) {
      state.calcSalary.loading = payload;
    },
  },
  actions: {
    async calcOperatorSalary({ commit }, data) {
      commit("MUTATE_CALC_SALARY_LOADING", true);
      try {
        const response = await axios.post("calculator/calculate-motivation", {...data});
        if(response?.data?.data) {
          commit("MUTATE_CALC_SALARY", response.data.data.salary);
          return response.data.data.salary;
        }
      } catch (e) {
        //eslint-disable-next-line
        console.log(e);
        throw e;
      } finally {
        commit("MUTATE_CALC_SALARY_LOADING", false);
      }
    },
  },
};